
/**
* @summary - Component that Provides License Type Code Creation Page
* @author Aro J
* @since 2024-06-10
*/
import { Box, Grid } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { DefaultCard } from "../../assets/styled-components/card";
import { MasterGraph } from "../../utility/apiURLS";
import { getAuthToken, getCreatedBy, getModifiedBy, getcompanyId } from "../../utility/tokenUtility";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomFooter from "../commoncomponents/CustomFooter";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import PageTitle from "../commoncomponents/PageTitle";

const CreateLicenseTypeCode = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [service, setService] = useState('');
    const [serviceOptions, setServiceOptions] = useState([]);
    const [licenseType, setLicenseType] = useState('');
    const [licenseTypeOptions, setLicenseTypeOptions] = useState([]);
    const [licntypecode, setLicntypecode] = useState('');
    const [licntypevalue, setLicntypevalue] = useState('');
    const [dialogContent, setDialogContent] = useState('');
    const [isChanged, setIsChanged] = useState(false);

    const [readOnlyEdit, setReadOnlyEdit] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [openValidationDialog, setOpenValidationDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [contentDialog, setContentDialog] = useState("");
    const [enableSubmit, setEnableSubmit] = useState(true);
    const [isView, setIsView] = useState(false);
    const [isAddNew, setIsAddNew] = useState(false);
    const [rowData, setRowData] = useState({});
    const [errors, setErrors] = useState({
        service: false,
        licenseType: false,
        licntypecode: false,
        licntypevalue: false,
    });

    const [errorMessages, setErrorMessages] = useState({
        service: '',
        licenseType: '',
        licntypecode: '',
        licntypevalue: '',
    });

    const token = getAuthToken("id_token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const companyId = getcompanyId('companyId');
    const createdBy = getCreatedBy('createdBy');
    const modifiedBy = getModifiedBy('modifiedBy');

    useEffect(() => {
        if (location.state) {
            const { rowData, isEditMode } = location.state;
            setRowData(rowData);
            setIsEdit(isEditMode);
            setReadOnlyEdit(!!isEditMode);
        }
        fetchEditData();
        fetchServiceOptions();
        fetchLicenseTypeOptions();
    }, [location.state, isEdit]);

    const fetchEditData = () => {
        setService(isEdit ? rowData.service : "");
        setLicenseType(isEdit ? rowData.licenseType : "");
        setLicntypecode(isEdit ? rowData.licntypecode : "");
        setLicntypevalue(isEdit ? rowData.licntypevalue : "");
    };

    const fetchServiceOptions = async () => {
        try {
            const response = await axios.get(`${MasterGraph}/api/masservicedetails`, config);
            const filteredOptions = response.data.filter(option => option.service);
            setServiceOptions(filteredOptions.map(option => ({
                label: option.service,
                value: option.service,
                id: option.id
            })));

        } catch (error) {
            console.error("Error fetching service options:", error);
        }
    };

    const fetchLicenseTypeOptions = async () => {
        try {
            const response = await axios.get(`${MasterGraph}/api/maslicensetypes`, config);
            const filteredOptions = response.data
                .filter(option => option.licenseType)
                .sort((a, b) => a.licenseType.localeCompare(b.licenseType));

            setLicenseTypeOptions(filteredOptions.map(option => ({
                label: option.licenseType,
                value: option.licenseType,
                id: option.id
            })));
        } catch (error) {
            console.error("Error fetching license type options:", error);
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        let formIsValid = true;
        const newErrors = {
            service: false,
            licenseType: false,
            licntypecode: false,
            licntypevalue: false
        };
        const newErrorMessages = {
            service: '',
            licenseType: '',
            licntypecode: '',
            licntypevalue: ''
        };

        if (!service) {
            formIsValid = false;
            newErrors.service = true;
            newErrorMessages.service = 'Service is required';
        }
        if (!licenseType) {
            formIsValid = false;
            newErrors.licenseType = true;
            newErrorMessages.licenseType = 'License Type is required';
        }

        if (!licntypecode) {
            formIsValid = false;
            newErrors.licntypecode = true;
            newErrorMessages.licntypecode = 'License Type Code is required';
        } else if (licntypecode.startsWith(' ')) {
            formIsValid = false;
            newErrors.licntypecode = true;
            newErrorMessages.licntypecode = 'Space not allowed at the beginning';
        } 
        else if (licntypecode.endsWith(' ')) {
            formIsValid = false;
            newErrors.licntypecode = true;
            newErrorMessages.licntypecode = 'Space not allowed at the end';
        }
        
        
        else if (licntypecode.includes('  ')) {
            formIsValid = false;
            newErrors.licntypecode = true;
            newErrorMessages.licntypecode = 'Double Space not allowed';
        } else if (!/^[a-zA-Z0-9 /-]*$/.test(licntypecode)) {
            formIsValid = false;
            newErrors.licntypecode = true;
            newErrorMessages.licntypecode = 'Invalid Characters in License Type Code';
        }
        if (!licntypevalue) {
            formIsValid = false;
            newErrors.licntypevalue = true;
            newErrorMessages.licntypevalue = 'License Type Description is required';
        } else if (licntypevalue.startsWith(' ')) {
            formIsValid = false;
            newErrors.licntypevalue = true;
            newErrorMessages.licntypevalue = 'Space not allowed at the beginning';
        } else if (licntypevalue.includes('  ')) {
            formIsValid = false;
            newErrors.licntypevalue = true;
            newErrorMessages.licntypevalue = 'Double Space not allowed';
        } else if (!/^[a-zA-Z0-9,!@#$%&*()_\- ]*$/.test(licntypevalue)) {
            formIsValid = false;
            newErrors.licntypevalue = true;
            newErrorMessages.licntypevalue = 'Invalid Characters in License Type Description';
        }
        setErrors(newErrors);
        setErrorMessages(newErrorMessages);

        if (formIsValid) {
            handleSave();
        }
    };

    const handleCancel = () => {
        if (!isChanged) {
            navigate(-1, { replace: true });
        }
        else {
            setCancelDialogOpen(true)
            setDialogContent("Record(s) not Saved/Updated. Do you want to continue?")
        }
    };
    const handleAddNew = () => {
        if (isChanged) {
            setIsAddNew(true);
            setCancelDialogOpen(true);
            setDialogContent("Record(s) not Saved/Updated. Do you want to continue?");
        } else {
            setDefault();
        }
    };



    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };

    const handleConfirmCancel = () => {
        setCancelDialogOpen(false)
        setOpenValidationDialog(false)
        if (isAddNew) {
            setDefault()
        }

        if (isChanged && !isAddNew && !openValidationDialog) {
            setCancelDialogOpen(false);
            navigate(-1, { replace: true });
        }

    };

    const handleServiceChange = (newValue) => {
        setIsChanged(true);
        setService(newValue);
        if (newValue) {
            setErrors((prevErrors) => ({ ...prevErrors, service: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, service: '' }));
        }
    };

    const handleLnTypeChange = (newValue) => {
        setIsChanged(true);
        setLicenseType(newValue);
        if (newValue) {
            setErrors((prevErrors) => ({ ...prevErrors, licenseType: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licenseType: '' }));
        }
    };

    const handleLnCodeChange = (newValue) => {
        setIsChanged(true);
        setLicntypecode(newValue);
        const regex = /^[a-zA-Z0-9 /-]*$/;

        if (!regex.test(newValue)) {
            setErrors((prevErrors) => ({ ...prevErrors, licntypecode: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licntypecode: 'Invalid Characters in License Type Code' }));
        } else if (newValue.startsWith(' ')) {
            setErrors((prevErrors) => ({ ...prevErrors, licntypecode: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licntypecode: 'Space not allowed at the beginning' }));
        }
        else if (newValue.endsWith(' ')) {
            setErrors((prevErrors) => ({ ...prevErrors, licntypecode: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licntypecode: 'Space not allowed at the end' }));
          }
         else if (newValue.includes('  ')) {
            setErrors((prevErrors) => ({ ...prevErrors, licntypecode: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licntypecode: 'Double Space not allowed' }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, licntypecode: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licntypecode: '' }));
        }
    };

    const handleLnDescChange = (newValue) => {
        setIsChanged(true);
        setLicntypevalue(newValue);
        const regex = /^[a-zA-Z0-9,!@#$%&*()_\- ]*$/;

        if (!regex.test(newValue)) {
            setErrors((prevErrors) => ({ ...prevErrors, licntypevalue: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licntypevalue: 'Invalid Characters in License Type Description' }));
        } else if (newValue.startsWith(' ')) {
            setErrors((prevErrors) => ({ ...prevErrors, licntypevalue: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licntypevalue: 'Space not allowed at the beginning' }));
        } else if (newValue.includes('  ')) {
            setErrors((prevErrors) => ({ ...prevErrors, licntypevalue: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licntypevalue: 'Double Space not allowed' }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, licntypevalue: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, licntypevalue: '' }));
        }
    };

    const handleSave = async () => {
        try {
            const payload = {
                companyid: companyId,
                licntypecode,
                licntypevalue,
                mascalibrationcertheaders: [],
                maslicensecertheaders: [],
                createdby: createdBy,
                // createddate: "2024-06-25T15:00:55.029751",
                // modifiedby: "00000000-0000-0000-0000-000000000000",
                // modifieddate: "2024-06-25T15:14:13.4093805+05:30",
                isdeleted: false,
                id: rowData.id,
                masservicedetailsId:service.id,
                maslicensetypeId:licenseType.id,
                // masservicedetails: {
                //     id: service.id,
                //     service: service.value,
                //     servicedesc: service.label,
                // },
                // maslicensetype: {
                //     id: licenseType.id,
                //     licenseType: licenseType.value,
                //     servicedes: licenseType.label,
                // }
            };
            let response
            if (isEdit) {
                response = await axios.put(`${MasterGraph}/api/maslicensetypecodedetails/${rowData.id}`, payload, config);
            } else {
                response = await axios.post(`${MasterGraph}/api/maslicensetypecodedetails`, payload, config);
            }
            if (response.status == 201) {
                setOpenValidationDialog(true)
                setDialogContent('Data saved successfully.')
                setIsChanged(false)
            } else if (response.status == 200) {
                setOpenValidationDialog(true)
                setDialogContent('Data updated successfully.')
                setIsChanged(false)
            }
        } catch (error) {
            console.error("Error saving License Type Code:", error);
            if (error.response.status === 400) {
                setDialogContent("License Type Code Already Exists")
                setOpenValidationDialog(true)
            } else {
                setDialogContent("Error Occured!")
                setOpenValidationDialog(true)
            }
        }
    };

    const setDefault = () => {
        setService('');
        setLicenseType('');
        setLicntypecode('');
        setLicntypevalue('');
        setIsEdit(false);
        setErrors({ service: false, licenseType: false, licntypecode: false, licntypevalue: false });
        setErrorMessages({ service: '', licenseType: '', licntypecode: '', licntypevalue: '' });
        setIsChanged(false)
        setIsAddNew(false)
    };

    const handleDialogClose = () => {
        if (isChanged) {
            setOpenDialog(false);
        }
        if (isAddNew) {
            setIsAddNew(false);
        }
        setCancelDialogOpen(false);
        setOpenValidationDialog(false)
    };


    return (
        <>
            <PageTitle title={'Create License Type Code'}
                editTitle={'Edit License Type Code'}
                isEdit={isEdit}
            />
            <Box mt={{ xs: 1, md: 2 }}>
                <DefaultCard sx={{ height: "100%" }}>
                    <form onSubmit={handleSubmit} style={{ position: "relative" }}>
                        <Box mb={2}>
                            <Grid container spacing={4}>
                                <Grid item xs={6} md={4}>
                                    <CustomSelectInput
                                        id="service-label"
                                        label="Service"
                                        autoFocus={true}
                                        value={service}
                                        options={serviceOptions}
                                        onChange={handleServiceChange}
                                        disabled={readOnlyEdit}
                                        isMandatoryField={true}
                                        error={errors.service}
                                        errorMessage={errorMessages.service}
                                    />
                                </Grid>

                                <Grid item xs={6} md={4}>
                                    <CustomSelectInput
                                        label="License Type"
                                        value={licenseType}
                                        options={licenseTypeOptions}
                                        onChange={handleLnTypeChange}
                                        isMandatoryField={true}
                                        error={errors.licenseType}
                                        errorMessage={errorMessages.licenseType}
                                    />
                                </Grid>

                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        maxlength={30}
                                        label="License Type Code"
                                        id="asset-category-description"
                                        value={licntypecode}
                                        onChange={handleLnCodeChange}
                                        disabled={readOnlyEdit}
                                        isMandatoryField={true}
                                        error={errors.licntypecode}
                                        errorMessage={errorMessages.licntypecode}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        maxlength={255}
                                        label="License Type Description"
                                        id="asset-category-description"
                                        value={licntypevalue}
                                        onChange={handleLnDescChange}
                                        isMandatoryField={true}
                                        error={errors.licntypevalue}
                                        errorMessage={errorMessages.licntypevalue}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                    <CustomFooter
                        cancelClick={handleCancel}
                        saveClick={handleSubmit}
                        addClick={handleAddNew}
                        buttonLabel={isEdit ? "Update" : "Save"}
                        isEdit={isEdit}
                        showAddButton={true}
                    />
                </DefaultCard>
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        justifyContent: { xs: "center", md: "end" },
                    }}
                >

                </Box>
            </Box>
            <CustomDialog
                open={cancelDialogOpen}
                onConfirm={handleConfirmCancel}
                onClose={handleDialogClose}
                content={dialogContent}
                confirmBtn={'Yes'}
                cancelBtn={'No'}
            />
            <CustomDialog
                open={openValidationDialog}
                onConfirm={handleConfirmCancel}
                onClose={handleDialogClose}
                content={dialogContent}
                confirmBtn={'Ok'}

            />
        </>
    );
};

export default CreateLicenseTypeCode

